import apiClient from '@/plugins/axios';

export default {
	
	getRoundHistoryInfos(searchParam) {
		const langCode = localStorage.getItem('lang') || 'sv';

		let query = `?PageNumber=${searchParam.currentPage}&PageSize=${searchParam.pageSize}`;
		query += searchParam.roundHistoryId
			? `&RoundHistoryId=${searchParam.roundHistoryId}`
			: '';
		query += searchParam.orderBy ? `&OrderBy=${searchParam.orderBy}` : '';
		query += `&langCode=${langCode}`;

		return apiClient.get(`v1/RoundHistoryInfo${query}`);
	},

	getRoundHistoryInfo(roundHistoryInfoId) {
		const langCode = localStorage.getItem('lang') || 'sv';
		return apiClient.get(`v1/RoundHistoryInfo/${roundHistoryInfoId}`, {
			params: { langCode }
		});
	},

	createRoundHistoryInfo(roundHistoryInfo) {
		return apiClient.post('v1/RoundHistoryInfo', roundHistoryInfo);
	},

	updateRoundHistoryInfo(roundHistoryInfo) {
		var roundHistoryInfoId = roundHistoryInfo.id;

		return apiClient.put(
			`v1/RoundHistoryInfo/${roundHistoryInfoId}`,
			roundHistoryInfo
		);
	},

	deleteRoundHistoryInfo(roundHistoryInfoId) {
		return apiClient.delete(`v1/RoundHistoryInfo/${roundHistoryInfoId}`);
	}
};
